module.exports = __webpack_public_path__ + "static/img/korea-cash-payment.da0f77d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/korea-cash-payment.jpg
// module id = O7Gl
// module chunks = 0